import React, { Component } from 'react';
import { ImageLoader } from './ImageLoader';
import './Game_CraftingMaterial.css';
import GameAPI from './GameAPI';
import { MEDIA_VARIANTS } from '../../media';

export function getInventoryQuantity(inventory, itemId) {
    return (inventory || [])
        .filter(entry => String(entry?.itemId ?? entry?.ItemId) === String(itemId))
        .reduce((total, entry) => (
            total + Math.max(0, Number(entry?.quantity ?? entry?.Quantity) || 0)
        ), 0);
}

export const getCraftingQuantity = (inventory, storage, itemId) => (
    getInventoryQuantity(inventory, itemId)
    + getInventoryQuantity(storage, itemId)
);

const materialItemIds = materials => (materials || [])
    .map(material => String(material?.itemId ?? material?.ItemId ?? ''))
    .join('|');

export class Game_CraftingMaterial extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itemsLoaded: false,
        };
    }

    async componentDidMount() {
        await this.loadItems();
    }

    async componentDidUpdate(previousProps) {
        if (
            materialItemIds(this.props.craftingMaterial)
            !== materialItemIds(previousProps.craftingMaterial)
        ) {
            await this.loadItems();
        }
    }

    loadItems = async () => {
        this.setState({ itemsLoaded: false });
        const itemIds = (this.props.craftingMaterial || [])
            .map((item) => item.itemId);
        await GameAPI.fetchItems(itemIds);
        this.setState({ itemsLoaded: true });
    };

    render() {
        const hasInventory = Array.isArray(this.props.inventory)
            || Array.isArray(this.props.storage);

        return (
            <div className="Game_CraftingMaterial">
                <span className="Game_CraftingMaterial_Label">
                    Cost{hasInventory ? ' · required / available' : ''}
                </span>
                <div className="Game_CraftingMaterial_Container">
                    {this.props.craftingMaterial && this.props.craftingMaterial.map((item) => {
                        const required = Math.max(0, Number(item.amount) || 0);
                        const owned = hasInventory
                            ? Math.max(
                                0,
                                getCraftingQuantity(
                                    this.props.inventory,
                                    this.props.storage,
                                    item.itemId,
                                ) - Number(
                                    this.props.reservedMaterials?.get(
                                        String(item.itemId),
                                    ) || 0,
                                ),
                            )
                            : null;
                        const enough = owned === null || owned >= required;
                        const material = this.state.itemsLoaded
                            ? GameAPI.fetchItemCached(item.itemId)
                            : null;
                        const quantityLabel = owned === null
                            ? `${required} required`
                            : `${required} required, ${owned} available`;
                        const materialLabel = material?.name
                            ? `${material.name}: ${quantityLabel}`
                            : quantityLabel;
                        return (
                            <div
                                aria-label={materialLabel}
                                className={`Game_CraftingMaterial_Item${enough ? '' : ' is-missing'}`}
                                key={item.itemId}
                                title={materialLabel}
                            >
                                <ImageLoader
                                    className="craftingImage"
                                    imageId={material?.imageId}
                                    animatedMediaId={material?.animatedMediaId || material?.animatedImageId}
                                    staticPreview
                                    variant={MEDIA_VARIANTS.CARD}
                                />
                                <span className="craftingMatDetails">
                                    {material?.name ? (
                                        <span className="craftingMatName">
                                            {material.name}
                                        </span>
                                    ) : null}
                                    <span className="craftingMatAmount">
                                        {owned === null
                                            ? `${required}×`
                                            : `${required}/${owned}`}
                                    </span>
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
